import { NgClass, NgStyle } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { LoadingService } from '../../services/loading.service';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [NgClass, NgStyle],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.sass'
})
export class LoadingComponent implements OnDestroy {
  fillWidth = 0;
  visible = false;

  private fillTimer?: ReturnType<typeof setInterval>;
  private hideTimer?: ReturnType<typeof setTimeout>;
  private resetTimer?: ReturnType<typeof setTimeout>;

  constructor(private loadingService: LoadingService) {
    this.loadingService.loadingState.subscribe((isLoading: boolean) => {
      if (isLoading) {
        this.startLoading();
      } else {
        this.completeLoading();
      }
    });
  }

  private startLoading(): void {
    clearInterval(this.fillTimer);
    clearTimeout(this.hideTimer);
    clearTimeout(this.resetTimer);
    this.fillWidth = 0;
    this.visible = true;

    // Exponential ease-out: each tick adds 8% of the remaining distance to 85%
    this.fillTimer = setInterval(() => {
      const remaining = 85 - this.fillWidth;
      this.fillWidth += remaining * 0.08;
      if (this.fillWidth >= 84.9) {
        clearInterval(this.fillTimer);
      }
    }, 50);
  }

  private completeLoading(): void {
    clearInterval(this.fillTimer);
    clearTimeout(this.hideTimer);
    this.fillWidth = 100;

    // Fade out after fill transition (300ms) completes
    this.hideTimer = setTimeout(() => {
      this.visible = false;
      this.resetTimer = setTimeout(() => { this.fillWidth = 0; }, 300);
    }, 350);
  }

  ngOnDestroy(): void {
    clearInterval(this.fillTimer);
    clearTimeout(this.hideTimer);
    clearTimeout(this.resetTimer);
  }
}
